<nav class="navbar navbar-expand-md navbar-light">
    <div class="menu-group collapse navbar-collapse" id="navbarSupportedContent">
		<div class="title_costplanning">Cost Planning</div>

		<mat-nav-list class="inline">
			<a mat-list-item [routerLink]="['/aprrates']" routerLinkActive="active" #aprrate="routerLinkActive" class="menu">APR Rates</a>
			<a mat-list-item [routerLink]="['/dummyroutes']" routerLinkActive="active" #dummyroute="routerLinkActive" class="menu">Dummy Routes</a>
			<a mat-list-item [routerLink]="['/railpoints']" routerLinkActive="active" #railpoint="routerLinkActive" class="menu">Rail Points</a>
			<a mat-list-item routerLink="switchpoints" routerLinkActive="active" #switchpoint="routerLinkActive" class="menu">Switch Points</a>
		</mat-nav-list>

	</div>
</nav>